import { Phone, LogOut } from "lucide-react";
import { BRAND, FOOTER } from "@/lib/content";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ink text-bone">
      {/* CTA band */}
      <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-24">
        <div className="grid grid-cols-1 items-end gap-10 lg:grid-cols-2">
          <div>
            <p className="font-serif text-lg italic text-sage">{BRAND.tagline}</p>
            <h2 className="mt-4 font-serif text-4xl font-medium leading-tight tracking-tight text-bone sm:text-6xl">
              You don't have <br /> to decide alone.
            </h2>
          </div>
          <div className="flex flex-wrap gap-4 lg:justify-end">
            <a
              href="#hotlines"
              data-testid="footer-call-cta"
              className="inline-flex items-center gap-2 rounded-full bg-terracotta px-7 py-3.5 text-sm font-semibold text-white transition-transform duration-300 hover:scale-105"
            >
              <Phone className="h-4 w-4" strokeWidth={2.2} />
              Talk to someone
            </a>
            <button
              type="button"
              onClick={() => window.location.replace("https://www.weather.com")}
              data-testid="footer-quick-exit"
              className="inline-flex items-center gap-2 rounded-full border border-white/20 px-7 py-3.5 text-sm font-semibold text-bone transition-colors duration-300 hover:bg-white/10"
            >
              <LogOut className="h-4 w-4" strokeWidth={2.2} />
              Quick exit
            </button>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col gap-8 px-5 py-12 sm:px-8 lg:flex-row lg:justify-between">
          <div className="max-w-md">
            <p className="font-serif text-2xl font-medium text-bone">
              {BRAND.name}
              <span className="text-terracotta">.</span>
            </p>
            <p className="mt-4 text-sm leading-relaxed text-bone/60">{FOOTER.blurb}</p>
          </div>
          <div className="flex flex-col gap-3 text-sm">
            <p className="font-bold uppercase tracking-[0.18em] text-sage">Explore</p>
            <a href="#coercion" className="text-bone/70 transition-colors hover:text-bone">Your rights</a>
            <a href="#story" className="text-bone/70 transition-colors hover:text-bone">My story</a>
            <a href="#safety" className="text-bone/70 transition-colors hover:text-bone">Get to safety</a>
            <a href="#directory" className="text-bone/70 transition-colors hover:text-bone">Find help</a>
          </div>
        </div>
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-5 pb-10 sm:flex-row sm:items-center sm:justify-between sm:px-8">
          <p className="text-xs text-bone/50">
            © {new Date().getFullYear()} {BRAND.name}.
          </p>
          <p className="text-xs font-semibold text-terracotta">{FOOTER.emergency}</p>
        </div>
      </div>
    </footer>
  );
}
